export default "__VITE_ASSET__2f11b27b__"